module.exports = __webpack_public_path__ + "img/yxkheadtou.5783ffc6.svg";